import {createContext} from 'react';
import type {FormMakerActions, FormMakerContextProps, FormMakerImmutableStore, FormMakerState} from './form-maker.types';
import {CanvasDevice, DEFAULT_FIELDS_META, EditorViewport, FormMakerFormMode, RightPanelView} from './form-maker.types';

const noop = (): void => undefined;
const asyncNoop = (): Promise<boolean> => Promise.resolve(false);

const formMakerDefaultStore: FormMakerImmutableStore = {
  idEmailSignupForm: '',
  name: '',
  idOwner: 0,
  shareableUrl: '',
  isPublishedLink: false,
  isPublishedPopup: false,
  isPublishedEmbeddedForm: false,
  isAlreadyPublished: false,
  popupDelay: 0,
  shortPopupDelay: 0,
  longPopupDelay: 0,
  popupHtmlContent: '',
  iframePopupHtmlContent: '',
  embeddedFormHtmlContent: '',
  isSharedInTeam: false,
  canAutosave: false,
  isEmbedded: false,
  nextBtnCaption: '',
};

const formMakerDefaultState: FormMakerState = {
  hasUnsavedChanges: false,
  isSaving: false,
  saveFailed: false,
  saveErrorMessage: null,
  isEditorLoading: true,
  lastSavedAt: null,
  selectedComponent: null,
  editorViewport: EditorViewport.DESKTOP,
  canvasDevice: CanvasDevice.DESKTOP,
  previewMode: false,
  fieldsMeta: DEFAULT_FIELDS_META.map((f) => ({...f})),
  formMode: FormMakerFormMode.SIGNUP,
  rightPanelView: RightPanelView.DEFAULT,
};

const formMakerDefaultActions: FormMakerActions = {
  save: asyncNoop,
  undo: noop,
  redo: noop,
  setPreviewMode: noop,
  setCanvasDevice: noop,
  selectComponent: noop,
  setFieldsMeta: noop,
  setFormMode: noop,
  openRightPanelKeyboardShortcuts: noop,
  closeRightPanelOverlay: noop,
};

export const formMakerContext = createContext<FormMakerContextProps>({
  editor: null,
  store: formMakerDefaultStore,
  state: formMakerDefaultState,
  actions: formMakerDefaultActions,
});
